import {
    ApplicationHelpType,
    CaseFileStaticItems,
    DataScopesEnum,
} from '../../../../utilities/Constants';

import CheckmateSelect from '../../../shared/CheckmateSelect';
import CheckmateSelectHelper from '../../../../utilities/CheckmateSelectHelper';
import { Help } from '../../../shared/Help';
import { IUserModel } from '../../../../interfaces/IUser';
import { Stack } from 'react-bootstrap';
import { useGetQuadUsersByZone } from '../useGetQuadUsersByZone';

interface ICaseManagerControlProps {
    value: string | undefined;
    isPrimary: boolean;
    onChange: (selectedUser: IUserModel | undefined, staticItemId: number) => void;
    readonly?: boolean;
    zoneGuid: string;
}

export function CaseManagerControl(props: ICaseManagerControlProps) {
    const zoneUsersApi = useGetQuadUsersByZone(props.zoneGuid, DataScopesEnum.National.Value);
    const zoneUsers = zoneUsersApi.data ?? [];

    return (
        <Stack direction="horizontal" gap={2}>
            <div style={{ minWidth: 250, maxWidth: 300, width: '100%' }}>
                <CheckmateSelect
                    name={props.isPrimary ? 'caseManager' : 'alternateCaseManager'}
                    options={CheckmateSelectHelper.getUserOptions(zoneUsers)}
                    onChange={(selectedItem: any) =>
                        props.onChange(
                            zoneUsers.find((user) => user.guid === selectedItem?.guid),
                            props.isPrimary
                                ? CaseFileStaticItems.CaseManager.Id
                                : CaseFileStaticItems.AlternateCaseManager.Id
                        )
                    }
                    value={CheckmateSelectHelper.getSelectedUserValue(zoneUsers, props.value ?? '')}
                    isDisabled={props.readonly || zoneUsersApi.isError}
                    isLoading={zoneUsersApi.isFetching}
                />
            </div>

            {zoneUsersApi.isError && (
                <Help
                    helpText={zoneUsersApi.isError && 'Failed to load Case Managers'}
                    type={ApplicationHelpType.Error}
                    title="Error"
                    iconColorVariant="red"
                />
            )}
        </Stack>
    );
}
